import React, { useState } from 'react';
import { Box, Container, Flex, Text, Link, Divider, Image, HStack, Button } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../assets/images/logo4.png';
import SupportUsModal from './SupportUsModal';

const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Box as="footer" bg="white" shadow="md" m={4} mt={14}>
      <Container maxW="7xl" py={4} md={{ py: 8 }}>
        <Flex direction={{ base: 'column', sm: 'row' }} align={{ sm: 'center' }} justify="space-between">
          <Link as={RouterLink} to="/" display="flex" alignItems="center" mb={{ base: 4, sm: 0 }}>
            <Image src={logo} alt="Nervosscan Logo" h="8" mr={3} />
            <Text fontSize="2xl" fontWeight="semibold">
              Nervosscan
            </Text>
          </Link>

          <HStack spacing={6} mb={{ base: 6, sm: 0 }} fontSize="sm" fontWeight="medium" color="gray.500">
            <Link href="https://twitter.com/tianlitao3399" isExternal _hover={{ textDecoration: 'underline' }}>
              Contact
            </Link>
            <Button
              variant="link"
              color="gray.500"
              _hover={{ textDecoration: 'underline' }}
              // onClick={() => setIsModalOpen(true)}
            >
              Support Us
            </Button>
          </HStack>
        </Flex>

        <Divider my={6} borderColor="gray.200" />

        <Text fontSize="sm" color="gray.500" textAlign="center">
          2023 <Link as={RouterLink} to="/" _hover={{ textDecoration: 'underline' }}>Nervosscan</Link>. All Rights Reserved.
        </Text>
      </Container>

      <SupportUsModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </Box>
  );
};

export default Footer;
